import { render, staticRenderFns } from "./JobCard.vue?vue&type=template&id=02911618&"
import script from "./JobCard.vue?vue&type=script&lang=js&"
export * from "./JobCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports